import api from './api';

/**
 * SDR Campaign Services
 */

// Listar campanhas
export const getCampaigns = (params = {}) => {
  return api.get('/sdr/campaigns', { params });
};

// Obter campanha por ID
export const getCampaign = (campaignId) => {
  return api.get(`/sdr/campaigns/${campaignId}`);
};

// Criar campanha
export const createCampaign = (data) => {
  return api.post('/sdr/campaigns', data);
};

// Atualizar campanha
export const updateCampaign = (campaignId, data) => {
  return api.put(`/sdr/campaigns/${campaignId}`, data);
};

// Deletar campanha
export const deleteCampaign = (campaignId) => {
  return api.delete(`/sdr/campaigns/${campaignId}`);
};

/**
 * SDR Lead Services
 */

// Listar leads de uma campanha
export const getLeads = (campaignId, params = {}) => {
  return api.get(`/sdr/campaigns/${campaignId}/leads`, { params });
};

// Obter lead por ID
export const getLead = (leadId) => {
  return api.get(`/sdr/leads/${leadId}`);
};

// Atualizar lead
export const updateLead = (leadId, data) => {
  return api.put(`/sdr/leads/${leadId}`, data);
};

// Deletar lead
export const deleteLead = (leadId) => {
  return api.delete(`/sdr/leads/${leadId}`);
};

// Re-qualificar lead
export const requalifyLead = (leadId) => {
  return api.post(`/sdr/leads/${leadId}/requalify`);
};

/**
 * Lead Import Services
 */

// Upload de planilha de leads
export const uploadLeads = (campaignId, file, options = {}) => {
  const formData = new FormData();
  formData.append('file', file);

  // Opções de importação
  if (options.skipDuplicates !== undefined) {
    formData.append('skipDuplicates', options.skipDuplicates);
  }
  if (options.updateExisting !== undefined) {
    formData.append('updateExisting', options.updateExisting);
  }

  return api.post(`/sdr/campaigns/${campaignId}/upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

// Download template de planilha
export const downloadTemplate = () => {
  return api.get('/sdr/leads/template', {
    responseType: 'blob'
  });
};

/**
 * Discovery Services
 */

// Iniciar descoberta com Apollo.io
export const startDiscovery = (campaignId, criteria) => {
  return api.post(`/sdr/campaigns/${campaignId}/discover`, criteria);
};

// Status da descoberta
export const getDiscoveryStatus = (campaignId) => {
  return api.get(`/sdr/campaigns/${campaignId}/discovery/status`);
};

/**
 * Campaign Metrics
 */

// Obter métricas de uma campanha
export const getCampaignMetrics = (campaignId) => {
  return api.get(`/sdr/campaigns/${campaignId}/metrics`);
};

// Obter métricas gerais (todas as campanhas)
export const getOverallMetrics = () => {
  return api.get('/sdr/metrics');
};
